import { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'

const { t } = useI18n()

// 修改这里：将 RouteRecordRaw[] 改为 AppRouteRecordRaw[]
const dashboardRoutes: RouteRecordRaw[] = [
  {
    path: '/dashboard',
    component: Layout,
    redirect: '/dashboard/welcome',
    name: 'Dashboard',
    meta: {
      title: t('router.dashboard'),
      icon: 'vi-ant-design:dashboard-filled',
      alwaysShow: true
    },
    children: [
      {
        path: 'welcome',
        component: () => import('@/views/Dashboard/Welcome.vue'),
        name: 'Welcome',
        meta: {
          title: 'Welcome',
          noCache: true,
          affix: true,
          icon: 'mdi-hand-wave'
        }
      },
      {
        path: 'stat/index',
        component: () => import('@/views/Admin/Stat/Index.vue'),
        name: 'AdminStat',
        meta: {
          title: '首页统计',
          icon: 'mdi-home-analytics',
          noCache: true
        }
      },
      {
        path: 'analysis',
        component: () => import('@/views/Dashboard/Analysis.vue'),
        name: 'Analysis',
        meta: {
          title: t('router.analysis'),
          noCache: true,
          icon: 'mdi-chart-bar'
        }
      }
    ]
  }
]

export default dashboardRoutes
